"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const messageContent_1 = require("../candidConverters/messageContent");
const replyContext_1 = require("../candidConverters/replyContext");
const timestamp_1 = require("../candidConverters/timestamp");
const userId_1 = require("../candidConverters/userId");
const option_1 = require("../candidConverters/option");
const chat_1 = require("../candidConverters/chat");
const CanisterClientFactory_1 = __importDefault(require("../CanisterClientFactory"));
const httpError_1 = require("../../errors/httpError");
function default_1(userId, senderName, clientMessageId, content, repliesTo) {
    return __awaiter(this, void 0, void 0, function* () {
        const client = CanisterClientFactory_1.default.current.chatsClient;
        const canisterRequest = {
            recipient: userId_1.toCandid(userId),
            sender_name: option_1.toCandid(senderName),
            client_message_id: clientMessageId,
            content: messageContent_1.toCandid(content),
            replies_to: replyContext_1.toCandid(repliesTo)
        };
        let response;
        try {
            response = yield client.send_direct_message(canisterRequest);
        }
        catch (e) {
            return httpError_1.toHttpError(e);
        }
        if ("Success" in response) {
            let success = response.Success;
            return {
                kind: "success",
                result: {
                    chat: chat_1.directChatFromCandid(success.chat_summary),
                    messageId: success.message_id,
                    date: timestamp_1.toDate(success.timestamp)
                }
            };
        }
        else if ("UserNotFound" in response) {
            return { kind: "userNotFound" };
        }
        else if ("RecipientNotFound" in response) {
            return { kind: "recipientNotFound" };
        }
        else if ("BalanceExceeded" in response) {
            return { kind: "balanceExceeded" };
        }
        else if ("SenderBlocked" in response) {
            return { kind: "senderBlocked" };
        }
        else if ("RecipientBlocked" in response) {
            return { kind: "recipientBlocked" };
        }
        else {
            throw new Error("Unrecognised 'send_direct_message' response");
        }
    });
}
exports.default = default_1;
